import React from 'react';
import { Outlet } from 'react-router-dom';
import './ProjectLayout.css';
import './ProjectLayout-responsive.css';

const ProjectLayout: React.FC = () => {
    return (
        <div className='layout-main'>
            {/* <Navbar isOpen={false} showToggle={false} /> */}
            <div className="layout">
                <main className='main-content'>
                    <Outlet />
                </main>
            </div>
        </div>
    )
}

export default ProjectLayout;